class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    this.initCollapsibleMenus();

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }

  initCollapsibleMenus() {
    const collapsibleMenus = this.querySelectorAll("[data-footer-collapsible]");

    collapsibleMenus.forEach((wrapper) => {
      if (wrapper.dataset.accordionInit === "true") return;

      wrapper.dataset.accordionInit = "true";

      new MinimogLibs.Accordion(wrapper, {
        presetContentHeight: true,
        onload: true,
      });

      wrapper.querySelectorAll(".m-accordion--item-button").forEach((button) => {
        button.addEventListener("click", () => {
          const item = button.closest(".m-accordion--item");
          window.requestAnimationFrame(() => {
            button.setAttribute("aria-expanded", item?.classList.contains("open") ? "true" : "false");
          });
        });
      });
    });
  }
}
customElements.define("m-footer", MFooter);
